<div class="modal" [style.opacity]="show ? 1 : 0" >{{ message }}</div>
